/* eslint-disable vue/match-component-file-name */
import Vue from 'vue';

import PageHeader from '@/js/components/common/layout/PageHeader';
import TabItem from '@/js/components/common/layout/TabItem';

import ActionLabel from '@/js/components/action/ActionLabel';
import CounterLabel from '@/js/components/counter/CounterLabel';
import LanguageLabel from '@/js/components/common/labels/LanguageLabel';
import LoadingLabel from '@/js/components/common/labels/LoadingLabel';
import PublicationLabel from '@/js/components/publication/PublicationLabel';
import QueueLabel from '@/js/components/queue/QueueLabel';
import TemplateLabel from '@/js/components/template/TemplateLabel';
import UserLabel from '@/js/components/user/UserLabel';
import WorkflowLabel from '@/js/components/workflow/WorkflowLabel';
import TagLabel from '@/js/components/tag/TagLabel';

import BackButton from '@/js/components/common/buttons/BackButton';
import CreateButton from '@/js/components/common/buttons/CreateButton';
import QueryFilter from '@/js/components/common/controls/QueryFilter';
import FilteredByRelated from '@/js/components/common/controls/FilteredByRelated';
import SearchForm from '@/js/components/common/controls/SearchForm';
import ToggleTrashed from '@/js/components/common/controls/ToggleTrashed';
import ToggleScheduled from '@/js/components/common/controls/ToggleScheduled';

////////////////////////////////////////////////////////////////////////////////
///   COMPONENTS                                                             ///
////////////////////////////////////////////////////////////////////////////////

Vue.component('PageHeader', PageHeader);
Vue.component('TabItem', TabItem);

Vue.component('ActionLabel', ActionLabel);
Vue.component('CounterLabel', CounterLabel);
Vue.component('LanguageLabel', LanguageLabel);
Vue.component('LoadingLabel', LoadingLabel);
Vue.component('PublicationLabel', PublicationLabel);
Vue.component('QueueLabel', QueueLabel);
Vue.component('TemplateLabel', TemplateLabel);
Vue.component('UserLabel', UserLabel);
Vue.component('WorkflowLabel', WorkflowLabel);
Vue.component('TagLabel', TagLabel);

Vue.component('BackButton', BackButton);
Vue.component('CreateButton', CreateButton);
Vue.component('QueryFilter', QueryFilter);
Vue.component('FilteredByRelated', FilteredByRelated);
Vue.component('SearchForm', SearchForm);
Vue.component('ToggleTrashed', ToggleTrashed);
Vue.component('ToggleScheduled', ToggleScheduled);
